// A wasm build with panic=abort leaves a trapped method's `&mut self` borrow taken for good; every later call on
// that object throws this text. Nothing re-enters the renderer, so the text alone proves an earlier trap.
const POISONED_BORROW = 'recursive use of an object detected';

/** True when `error` means the wasm renderer trapped (out of memory, abort) and the instance is unusable. */
export function isWasmTrap(error: unknown): boolean {
  if (typeof WebAssembly !== 'undefined' && error instanceof WebAssembly.RuntimeError) return true;
  const message = error instanceof Error ? error.message : String(error);
  return message.includes(POISONED_BORROW);
}
